import React from "react";
import { ReactComponent as WarningIcon } from "../../../img/warning_triangle.svg";
import { GlobalStore } from "../../../store/global/GlobalStore";
import clsx from "clsx";
import { OrderStatus } from "../../../types/orderStatus";
import { Spacer } from "../../../components/general/Spacer/Spacer";

export interface WarningSectionProps {
  warning: string | undefined;
}

export const WarningSection: React.FC<WarningSectionProps> = ({ warning }) => {
  const orderStatus = GlobalStore.useState(s => s.orderStatus);
  const isWarningApplicable =
    orderStatus === OrderStatus.ENTRY || orderStatus === OrderStatus.QUOTING;

  return (
    <>
      <div
        data-testid={"warning-section"}
        className={clsx({
          "inline-error": true,
          "d-flex": true,
          "align-items-start": true,
          "warning-information": warning,
          "my-3": true,
        })}
        style={{ fontSize: "14px", padding: "10px", lineHeight: "20px" }}
      >
        <div style={{ width: "20px", height: "20px" }}>
          {warning && isWarningApplicable && (
            <WarningIcon width={20} height={20} strokeWidth={1.5} />
          )}
        </div>
        <Spacer width="10px" />
        {isWarningApplicable && warning}
      </div>
    </>
  );
};
